import {
  openModal,
  closeModal,
  stockItemList,
  stockItemDelete,
} from "../../../../../redux/actions/action-creator";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../accounting_master/group.css";
import { Link } from "react-router-dom";
import MasterListFooter from "../../../../../components/Footer/Master_Footer/MasterListFooter";
import { useDropdownKeyboardNavigation } from "../../../../../components/Custom_Hooks/useDropdownKeyboardNavigation";
import { useDropdownScroll } from "../../../../../components/Custom_Hooks/useDropdownScroll";
import HomeLayout from "../../../../../components/home_page/HomeLayout";
import Form from "../../../../../components/Form/Form";
import NavFooterLayout from "../../../../../components/NavNameOfComponent/NavFooterLayout";
import DeletConfirm from "../../../../../components/Modal/DeletConfirm";
import { useDelet } from "../../../../../components/Custom_Hooks/useDelete";
import { prepareFormData } from "../../../../../components/Custom_Hooks/useFormHandler";
import StockItemCreate from "../../create/Inventory_masters/StockItem";
import StockItemAlter from "../../alter/Inventory_masters/StockItem";
import StockItemView from "../../view/Inventory_masters/StockItemView";

const StockItem = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [all_data, setall_data] = useState([]);

  const [enabled, setEnabled] = useState(true);

  const { userData = null } = useSelector((state) => state.auth);
  const modal_state = useSelector((state) => state.common.modal_state);
  const dropdownRef = useRef(null);

  // fetch data ----------------------

  useEffect(() => {
    setEnabled(true);
    const fetchData = async () => {
      try {
        const formdata = new FormData();
        formdata.append('company_id', userData?.id);
        const response = await dispatch(stockItemList(formdata));
        if (response?.status && Array.isArray(response?.data)) {
          const sortedData = [...response.data].sort((a, b) => {
            const nameA = (a.name || "").toLowerCase();
            const nameB = (b.name || "").toLowerCase();

            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          setall_data(sortedData);
        } else {
          setall_data([]);
        }
        //setall_data(response?.data);
      } catch (error) {
        console.error('Error fetching group data:', error);
        setall_data([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [modal_state?.group_view, modal_state?.group_update, modal_state?.modal_1, modal_state?.modal_2])

  // keyboard Functionality ----------------------------------------
  const { selectedItemIndex, setSelectedItemIndex } =
    useDropdownKeyboardNavigation({
      items: all_data,
      state: (modal_state?.group_view || modal_state?.group_update || modal_state?.modal_1 || modal_state?.modal_2) ? false : true,
      onItemSelect: (item) => {
        if (!(modal_state?.group_update || modal_state?.modal_1 || modal_state?.modal_2)) {
          dispatch(openModal("group_view"));
        }
      },
      onItemControlEnterSelect: (item) => {
        if (!(modal_state?.modal_1 || modal_state?.modal_2 || modal_state?.group_view)) {
          // navigate(`../alter_accounting_groupupdate/${item?.data?.id}`)
          dispatch(openModal("group_update"));
        }
      },
      onItemAltCSelect: (item) => {
        if (!(modal_state?.group_update || modal_state?.modal_2 || modal_state?.group_view)) {
          dispatch(openModal("modal_1"));
        }
      },
      onItemAltDSelect: (item) => {
        if (!(modal_state?.group_update || modal_state?.modal_1 || modal_state?.group_view)) {
          dispatch(openModal("modal_2"));
        }
      },
    });
  // Scroll Functionality -------------------------------------
  useDropdownScroll({ dropdownRef, selectedItemIndex });

  const [data, setData] = useState({
    id: null,
    company_id: userData?.id,
  });

  useEffect(() => {
    if (all_data?.length > 0 && all_data[selectedItemIndex]) {
      setData({
        id: all_data[selectedItemIndex]?.id,
        company_id: userData?.id,
      });
    }
  }, [selectedItemIndex, all_data]);

  // Delete Functionality ------------------------------
  const { delteItem, loadingDelete } = useDelet({
    prepareFormData: () => prepareFormData(data),
    submitForm: (data) => dispatch(stockItemDelete(data)),
    shortcuts: [
      {
        key: "a",
        ctrlKey: true,
        action: () => delteItem(new Event("submit")),
      },
    ],
    closeModal: () => dispatch(closeModal("modal_2")),
    state: modal_state?.modal_2,
  });
  //console.log(all_data)
  return (
    <HomeLayout>
      {modal_state?.modal_1 && (
        <div style={{ zIndex: 10000, width: "100%" }}>
          <StockItemCreate
            title="Stock Item Creation (Primary)"
            closeModal_sec={() => dispatch(closeModal("modal_1"))}
          />
        </div>
      )}
      {
        // location.pathname === `/alter_accounting_groupupdate/${id}`
        modal_state?.group_update && (
          <div style={{ zIndex: 10000, width: "100%" }}>
            <StockItemAlter
              data_to_update={data}
              title="Stock Item Alteration"
              closeModal_sec={() => dispatch(closeModal("group_update"))}
            />
          </div>
        )
      }
      {
        modal_state?.group_view && (
          <div style={{ zIndex: 10000, width: "100%" }}>
            <StockItemView
              data_to_view={data}
              title="Stock Item View"
              closeModal_sec={() => dispatch(closeModal("group_view"))}
            />
          </div>
        )
      }
      <Form
        title="List of Stock Items"
        col="col-12"
        loading={loading}
        Footer={MasterListFooter}
        createMasterEnabled={enabled}
      >
        {modal_state?.modal_2 ? (
          <div style={{ zIndex: 10000, width: "100%" }}>
            <DeletConfirm
              handleSubmit={delteItem}
              loading={loadingDelete}
              closeModal={() => dispatch(closeModal("modal_2"))}
            />
          </div>
        ) : null}

        <div className="row p-0 m-0 border_2_1px_top border_2_2px_bottom  mt-0 ">
          <div
            className="col-1 font_size p-0 m-0 ps-3 text-end fw-bold"
            style={{ width: "3%" }}
          >
            Sr
          </div>
          <div
            className={`col-3 font_size p-0 m-0 ps-3 text-start fw-bold `}
          >
            Name of Item
          </div>

          <div
            className="col-3 font_size m-0 p-0 ps-3 text-start fw-bold "
          >
            Under
          </div>
          <div
            className="col-3 font_size m-0 p-0 ps-3 text-start fw-bold"
          >
            Company
          </div>
          <div
            className="col-1 font_size m-0 p-0 ps-3 text-start fw-bold "
          >
            Units
          </div>

          <div
            className="col font_size m-0 p-0 ps-3 text-start fw-bold "
          >
            Alt Unit
          </div>
        </div>

        <div className="row gx-0 p-0 mb-2" style={{ overflowY: "hidden" }}>
          <div
            className="col"
            ref={dropdownRef}
            style={{ overflowY: "auto", height: "78.3vh" }}
          >
            {all_data?.map((item, index) => {
              return (
                // <div
                //   key={index}
                //   className={index === selectedItemIndex ? "selected" : ""}
                //   style={{
                //     display: "flex",
                //     textAlign: "left",
                //     paddingLeft: 5,
                //     // marginLeft: item.type === 'primary' ? 0 : item.type === 'secondary' ? 10 : item.type.startsWith('secondary') ? (item.type.length - 6) * 5 : 0
                //   }}
                // >
                //   <Link
                //     onClick={() => setSelectedItemIndex(index)}
                //     className={"group_list_chart_of_account"}
                //     style={{ width: "100%" }}
                //   >
                //     {item.name}
                //   </Link>
                // </div>
                <div
                  key={index}
                  onClick={() => setSelectedItemIndex(index)}
                  style={{ cursor: "pointer" }}
                  className={`row gx-0 p-0 m-0  mt-0 ${index === selectedItemIndex ? "selected" : ""}`}>
                  <div
                    className="col-1 font_size p-0 m-0 ps-3 text-end fw-bold"
                    style={{ width: "3%" }}
                  >
                    {index + 1}
                  </div>
                  <div
                    className={`col-3 font_size p-0 m-0 ps-3 text-start`}
                  >
                    {item?.name}
                  </div>

                  <div
                    className="col-3 font_size m-0 p-0 ps-3 text-start"
                  >
                    {item?.stock_group_name}
                  </div>
                  <div
                    className="col-3 font_size m-0 p-0 ps-3 text-start"
                  >
                    {item?.stock_company}
                  </div>
                  <div
                    className="col-1 font_size m-0 p-0 ps-3 text-start"
                  >
                    {item?.unit_name}
                  </div>

                  <div
                    className="col font_size m-0 p-0 ps-3 text-start"
                  >
                    {item?.alt_unit_name}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <NavFooterLayout>
          <b className="ps-2"> {all_data?.length} Stock Item(s)</b>
        </NavFooterLayout>
      </Form>
    </HomeLayout>
  );
};
export default StockItem;
